module.exports = __webpack_public_path__ + "img/govt_journeytogod.61a97d2.png";